export const radarKey = process.env.REACT_APP_RADAR_API_KEY
